import { Component, OnInit, ViewEncapsulation, AfterViewInit, OnDestroy } from '@angular/core';
import { ParameterHandlerService, CacheService } from 'projects/common/src/app/services';
import { BooleanStateService } from 'src/app/modules/core/services/boolean-state.service';
import { MachineContextService } from 'src/app/modules/core/services/parameter/machine-context/machine-context.service';
import { StateSidebarService } from 'src/app/modules/sidebar/services/state-sidebar.service';
import { CommunicationService } from 'src/app/services/communication';
import { DashboardWidgetChartComponent } from '../../../dashboard-widget-chart/dashboard-widget-chart.component';
import Highcharts from 'highcharts';
import { IShift } from '../../../../../core/interfaces/shift';
import { LanguageService } from '../../../../../../../../projects/common/src/app/services/parameters/language/language.service';
import { IProductionByStreetChart } from '../../../../../widget/interfaces/production-by-street';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductionByStreetModalComponent } from '../production-by-street-modal/production-by-street-modal.component';
import { InputDateFormatPipe } from '../../../../../core/pipes/input-date-format.pipe';
import { firstLetterUpper } from '../../../../../../../../projects/common/src/app/services/utils/util.service';
import { IModalInputs } from 'src/app/modules/widget/interfaces/production-type-truck-point';
import { ScreenViewService } from 'src/app/modules/widget/services/screen-view.service';
import { DashboardFacade } from 'src/app/modules/core/store/dashboard/dashboard.facade';

@Component({
  selector: 'app-production-by-street-chart',
  templateUrl: './production-by-street-chart.component.html',
  styleUrls: ['./production-by-street-chart.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProductionByStreetChartComponent extends DashboardWidgetChartComponent implements OnInit, AfterViewInit, OnDestroy {
  public date: string;
  public isTruck: boolean;
  public isLhd: boolean;

  public dataProd: any;
  public typeActive: boolean;
  public timeout;
  public showTable = false;
  public componentName = '';
  constructor(
    public dashboardFacade: DashboardFacade,
    protected progressBarService: BooleanStateService,
    protected communication: CommunicationService,
    protected parameterService: ParameterHandlerService,
    protected sidebarService: StateSidebarService,
    protected cacheService: CacheService,
    protected machineContext: MachineContextService,
    protected langService: LanguageService,
    protected modalService: NgbModal,
    protected inputDatePipe: InputDateFormatPipe,
    protected screenViewService: ScreenViewService, // public dashboardFacade: DashboardFacade,
  ) {
    super(progressBarService, communication, parameterService, sidebarService, cacheService, machineContext, screenViewService);
    this.initRequestParams();
  }

  /**
   * Init request params
   */
  protected initRequestParams(): void {
    this.params = {
      hasDate: true,
      hasShift: true,
      hasCompany: true,
      hasZone: true,
    };
  }

  /**
   * on Init component
   */
  public ngOnInit(): void {
    super.ngOnInit();
    this.isLhd = true;
    this.isTruck = false;
  }

  public ngAfterViewInit(): void {
    this.dashboardFacade.dashboardModel$.subscribe((value) => {
      this.showTable = value.isShowTable;
      this.componentName = value.rawComponent?.visibleName;
    });
  }
  /**
   * Function to draw chart
   *
   * @param chartOptions ChartOptions
   */
  public async drawView(chartOptions: any): Promise<void> {
    this.date = this.parameterService.parameters.item('date').value;
    const shift = this.parameterService.parameters.item('shift').value as IShift;

    this.typeActive = false;

    this.dataProd = chartOptions;

    if (this.dataProd) {
      this.setChartConfig(shift, this.dataProd, this.typeActive);
      this.hasData = true;
    } else {
      this.hasData = false;
    }
  }

  /**
   * Function to declare & init chart properties
   *
   * @param shiftId Shift ID to get loops
   * @param prodByStreetList data to fill chart view
   */
  protected setChartConfig(shift: IShift, dataProdList: any, type: boolean): void {
    const user = this.parameterService.parameters.item('user-data').value;
    const machineType = this.parameterService.parameters.item('machine-context').value || 'no disponible';
    const { openModal } = this;
    const modalSvc = this.modalService;
    const { categories, xtext, ytext, shiftName, series } = this.defineChartProperties(shift, dataProdList);
    const { defineTooltipHtml } = this;
    const { date } = this;
    const { zoneName } = this.cacheService.session('selectedZone');
    const streetLabel = firstLetterUpper(this.langService.message('street'));
    // let chartTitle = '';
    // if (zoneName !== '') {
    //   chartTitle = `${zoneName} - ${this.inputDatePipe.transform(date)}`;
    // } else {
    //   chartTitle = `${this.inputDatePipe.transform(date)}`;
    // }

    const data = {
      chart: {
        type: 'column',
        backgroundColor: '#F8F8F8',
        height: 450,
        marginRight: 40,
      },
      title: {
        text: '',
        y: 20,
        style: {
          fontSize: 13,
          fontWeight: '600',
          fontFamily: 'Open Sans',
          color: '#433E3E',
        },
      },
      credits: {
        enabled: false,
      },
      subtitle: {
        text: `${this.langService.message('company')}: ${user.company.name},
              ${this.langService.message('device')}: ${this.langService.message(machineType.name)},
              ${this.langService.message('date')}: ${this.inputDatePipe.transform(date)},
              ${this.langService.message('shift_')}: ${shift.name}`,
      },
      xAxis: {
        categories,
        title: {
          text: xtext,
          margin: 10,
          style: {
            fontSize: 12,
            color: '#707070',
            fontWeight: '600',
            fontFamily: 'Open Sans',
          },
        },
        gridLineWidth: 1,
        labels: {
          useHTML: true,
          rotation: -45,
          padding: 0,
          step: 1,
          style: {
            color: '#707070',
            fontSize: '10px',
            fontWeight: '400',
            padding: '0px',
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: ytext,
          style: {
            fontSize: 12,
            color: '#707070',
            fontWeight: '600',
            fontFamily: 'Open Sans',
          },
        },
      },
      legend: {
        squareSymbol: false,
        align: 'center',
        verticalAlign: 'top',
        symbolHeight: 0.001,
        symbolWidth: 0.001,
        symbolRadius: 0.001,
        margin: 30,
        reversed: true,
        itemStyle: {
          fontSize: 12,
          fontWeight: '600',
          fontFamily: 'Open Sans',
          color: '#433E3E',
        },
        itemCheckboxStyle: {
          color: '#ffffff',
        },
        useHTML: true,
        labelFormatter(): string {
          return `
          <div style=" height: 20px; display: flex;">
            <svg width="36" height="18" style=" float: left;">
              <rect width="30" height="12" x="2" y="2"
              style="fill: ${this.color}; stroke-width: 2px !important;
              stroke: ${this.color.slice(0, -2)} !important;"/>
            </svg>

            <span style="font-size: 12px; font-family: Open Sans; font-weight: 500;
            color: #433E3E; float: left;">${this.name}</span>
          </div>`;
        },
      },
      tooltip: {
        hideDelay: 0,
        backgroundColor: '#333333',
        borderColor: '#333333',
        borderRadius: 15,
        className: 'tooltip-zindex',
        outside: true,
        style: {
          color: 'white',
          fontFamily: 'Open Sans',
          fontSize: '10px',
        },
        useHTML: true,
        formatter(): string {
          const tooltipProps = {
            shiftName,
            streetLabel,
            key: this.key,
            color: this.color,
            y: this.y,
            series: this.series,
          };
          return defineTooltipHtml(tooltipProps);
        },
      },
      plotOptions: {
        series: {
          marker: {
            enabled: true,
            width: 10,
          },
          stacking: 'normal',
          cursor: 'pointer',
          maxPointWidth: 25,
          dataLabels: {
            enabled: true,
            allowOverlap: false,
            verticalAlign() {
              return this.y === 0 ? 'bottom' : 'top';
            },
            style: {
              color: '#707070',
              textOutline: 'none',
              fontWeight: '600',
              fontSize: '11px',
              fontFamily: 'Open Sans',
            },
            y: -20,
          },
          point: {
            events: {
              click(): void {
                const inputs: IModalInputs = {
                  modalSvc,
                  shiftName,
                  shift,
                  date,
                  zoneName,
                  id: this.id,
                  category: this.category,
                };
                openModal(inputs);
              },
            },
          },
          events: {
            legendItemClick: (e) => {
              e.preventDefault();
            },
          },
        },
      },
      series,
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500,
            },
            chartOptions: {
              chart: {
                className: 'small-chart',
              },
            },
          },
        ],
      },
    };

    this.timeout = setTimeout(() => (this.chart = Highcharts.chart(this.chartTarget.nativeElement, data as any, (chart) => {})), 0);
  }

  /**
   * Build html tooltip for chart
   *
   * @param tooltipProps properties to build tooltip
   */
  protected defineTooltipHtml(tooltipProps: any): string {
    const html = `<div style="width: 150px;">
        <strong>${tooltipProps.shiftName.toUpperCase()}</strong> <br>
        <span>${tooltipProps.streetLabel} ${tooltipProps.key}</span> <br>
        <div style="margin-top: 2px;">
          <svg width="20" height="13" style="float: left; margin-right: 5px; border-radius: 1px;">
            <rect width="20" height="13" style="fill:${tooltipProps.color.slice(0, -2)};"/>
          </svg>
          <span>${tooltipProps.y} ${tooltipProps.series.name}</span>
        </div>
      </div>`;

    return html;
  }

  /**
   * Define chart config properties
   *
   * @param shift shift object to build labels
   * @param dataProdList production list to build categories for char
   */
  protected defineChartProperties(shift: IShift, dataProdList: any): any {
    const shiftName = this.setShiftName(shift);
    const categories = dataProdList.productionByStreet.map((production) => production.zoneName);
    const xtext = this.langService.message('street').toUpperCase();
    const ytext = this.langService.message('shelves').toUpperCase();
    const series = this.buildSeriesForChart(dataProdList);

    const allZeros = series.every((item) => item.data.every((point) => point.y === 0));

    if (allZeros) {
      this.chartWithoutData$.next(true);
    } else this.chartWithoutData$.next(false);
    return { categories, xtext, ytext, shiftName, series };
  }

  /**
   * open modal
   *
   * @param inputs data to open modal
   */
  protected openModal(inputs: IModalInputs): void {
    const modalRef = inputs.modalSvc.open(ProductionByStreetModalComponent, {
      centered: true,
      size: 'lg',
      windowClass: 'prod-street-modal-width',
    });
    modalRef.componentInstance.modalSubtitle = inputs.shiftName;
    modalRef.componentInstance.shift = inputs.shift;
    modalRef.componentInstance.streetId = inputs.id;
    modalRef.componentInstance.streetName = inputs.category;
    modalRef.componentInstance.date = inputs.date;
    modalRef.componentInstance.shiftLabel = inputs.shiftName;
    modalRef.componentInstance.zoneName = inputs.zoneName;
  }

  /**
   * Function to build shift labels
   *
   * @param shift shift to evaluate
   */
  protected setShiftName(shift: IShift): string {
    let shiftName = `${this.langService.message('shift_')} ${shift.name}`;
    if (shift.shiftId === -1) {
      const dayDetail = this.langService.message('day_detail');
      shiftName = dayDetail[0].toUpperCase() + dayDetail.slice(1);
    }
    return shiftName;
  }

  /**
   * Function to build series for display chart values
   *
   * @param prodByStreetList data to fill chart view
   */
  protected buildSeriesForChart(prodByStreetList: IProductionByStreetChart): any {
    return [
      {
        name: this.langService.message('notscheduleddoneloops'), // notScheduledDoneLoops
        data: prodByStreetList.productionByStreet.map((production) => {
          return { id: production.zoneId, y: production.notScheduledDoneLoops };
        }),
        color: '#29BCDE80',
        borderColor: '#29BCDE',
        borderWidth: 2,
        states: {
          hover: {
            color: '#29BCDE',
          },
        },
      },
      {
        name: this.langService.message('remaindertodone'), // remainderToDone
        data: prodByStreetList.productionByStreet.map((production) => {
          return { id: production.zoneId, y: production.remainderToDone };
        }),
        color: '#D3721880',
        borderColor: '#D37218',
        borderWidth: 2,
        states: {
          hover: {
            color: '#D37218',
          },
        },
      },
      {
        name: this.langService.message('todone'),
        data: prodByStreetList.productionByStreet.map((production) => {
          return { id: production.zoneId, y: production.toDone };
        }),
        color: '#AFAFAF80',
        borderColor: '#AFAFAF',
        borderWidth: 2,
        states: {
          hover: {
            color: '#AFAFAF',
          },
        },
      },
      {
        name: this.langService.message('total-shelves'), // scheduledDone
        data: prodByStreetList.productionByStreet.map((production) => {
          return { id: production.zoneId, y: production.scheduledDone };
        }),
        color: '#22D98380',
        borderColor: '#22D983',
        borderWidth: 2,
        states: {
          hover: {
            color: '#22D983',
          },
        },
      },
    ];
  }

  /**
   * On destroy component
   */
  public onDestroy(): void {
    super.ngOnDestroy();
    clearTimeout(this.timeout);
  }
}
